// src/api/meteoFranceApi.ts — source alternative de DJU/températures (base Météo-France pré-calculée, /api/meteofrance)

import { request } from "./http";

export interface StationCandidate {
  id: number; nom: string; lat: number; lon: number;
  dateDebut: number; dateFin: number; count: number; missing: number;
  distanceKm: number; completeForYear: boolean; missingDaysInYear: number;
}

export interface NearestStationsResult { candidates: StationCandidate[]; recommended: number | null; }

export function fetchNearestStations(lat: number, lon: number, year: number): Promise<NearestStationsResult> {
  const qs = `lat=${lat}&lon=${lon}&year=${year}`;
  return request<NearestStationsResult>(`/meteofrance/stations/nearest?${qs}`);
}

/** Recherche par nom sur toute la base de stations (pas seulement les plus proches). */
export function searchStations(q: string, lat: number, lon: number, year: number): Promise<{ candidates: StationCandidate[] }> {
  const qs = `q=${encodeURIComponent(q)}&lat=${lat}&lon=${lon}&year=${year}`;
  return request<{ candidates: StationCandidate[] }>(`/meteofrance/stations/search?${qs}`);
}

export interface StationWeather {
  monthlyTemp:     Record<string, number>;
  monthlyDju:      Record<string, number>;
  /** DJU climatisation/rafraîchissement (colonne "froid") — cf. toggle chauffage/climatisation. */
  monthlyDjuFroid: Record<string, number>;
  complete:    boolean;
  missingDays: number;
  station: { id: number; nom: string; lat: number; lon: number };
}

export function fetchStationWeather(numPoste: number, year: number): Promise<StationWeather> {
  return request<StationWeather>(`/meteofrance/stations/${numPoste}/weather?year=${year}`);
}
